__webpack_require__.p = "/reports-dashboard-templates-routing/referrals-hub/";